import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { TranslationProvider } from './components/TranslationContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Entreprise from './pages/Entreprise';
import SavoirFaire from './pages/SavoirFaire';
import Values from './pages/Values';
import Equipe from './pages/Equipe';
import './styles/root.css';

function App() {
  return (
    <TranslationProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/entreprise" element={<Entreprise />} />
          <Route path="/savoirfaire" element={<SavoirFaire />} />
          <Route path="/values" element={<Values />} />
          <Route path="/equipe" element={<Equipe />} />
        </Routes>
        <Footer />
      </Router>
    </TranslationProvider>
  );
}

export default App;
